module.exports = __webpack_public_path__ + "static/img/get-perked-logo-250.4dc6063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/get-perked-logo-250.png
// module id = algo
// module chunks = 44